(() => {
  document.querySelectorAll('[data-gp-ssh-tabs]').forEach((tabs) => {
    const buttons = [...tabs.querySelectorAll('[role="tab"]')];
    const panels = [...tabs.querySelectorAll('[role="tabpanel"]')];

    const activate = (button) => {
      buttons.forEach((item) => item.setAttribute('aria-selected', 'false'));
      panels.forEach((panel) => panel.classList.remove('is-active'));

      button.setAttribute('aria-selected', 'true');
      const panel = tabs.querySelector(`#${button.getAttribute('aria-controls')}`);
      if (panel) panel.classList.add('is-active');
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => activate(button));
    });
  });
})();
